import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$emailsDepartment$, _vm$emailsDepartment$2, _vm$emailsDepartment$3, _vm$emailsDepartment$4, _vm$emailsDepartment$5, _vm$emailsDepartment$6;
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.hasAccessToPage ? _c("Error", {
    attrs: {
      error: {
        title: "Access not granted",
        description: "You are not allowed to access to this functionality.",
        link: "userHome",
        linkTitle: "home"
      }
    }
  }) : _c("section", {
    staticClass: "content-centered large text-left"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("E-mail of departments")]), _c(VTab, {
    key: 2
  }, [_vm._v("Identification numbers")])], 1), _c(VTabsItems, {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", {
    staticClass: "settings-tab"
  }, [_c(VAlert, {
    staticClass: "my-1",
    attrs: {
      dense: "",
      outlined: "",
      type: "info",
      color: "blue",
      text: ""
    }
  }, [_vm._v(" You have the possibility to assign one or more e-mails per department. These emails are notified at each stage of order processing depending on the nature of the action. e.g. Processes such as order validation will notify the sales team at "), _c("strong", [_vm._v("sales@example.io")]), _vm._v(" while goods movements will be notified at "), _c("strong", [_vm._v("logistic@example.io")]), _vm._v(" . "), _c("br"), _vm._v(" The first address will be used to send emails to customers. "), _c("br"), _vm._v(" If there is a specific adress for a country of a department, the first specific adress will be used used to send emails. ")]), _vm.isLoading ? _c(VSkeletonLoader, {
    attrs: {
      type: "card"
    }
  }) : _c(VForm, {
    staticClass: "settings-form",
    model: {
      value: _vm.emailsDepartment.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "isValid", $$v);
      },
      expression: "emailsDepartment.form.isValid"
    }
  }, [_c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Contact")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v(" The contact address is notified for any general communication, e.g. new user subscription. ")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("contact");
      },
      paste: function paste($event) {
        return _vm.updateTags("contact");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.contact,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "contact", $$v);
      },
      expression: "emailsDepartment.form.contact"
    }
  }), ((_vm$emailsDepartment$ = _vm.emailsDepartment.form.contactLimited) === null || _vm$emailsDepartment$ === void 0 ? void 0 : _vm$emailsDepartment$.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.contactLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "contactLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("contact", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("contact", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("contact", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("contact");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Order")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v(" The order address is notified for all order-related communication, e.g. new order registration. "), _c("br"), _vm._v(" The order address is used to send emails to customer during the order process. "), _c("br"), _vm._v(" The country of the billing address of the order is used to define which address is used ")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("order");
      },
      paste: function paste($event) {
        return _vm.updateTags("order");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "order", $$v);
      },
      expression: "emailsDepartment.form.order"
    }
  }), ((_vm$emailsDepartment$2 = _vm.emailsDepartment.form.orderLimited) === null || _vm$emailsDepartment$2 === void 0 ? void 0 : _vm$emailsDepartment$2.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.orderLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "orderLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("order", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("order", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("order", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("order");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Logistic")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v(" The logistic address is notified for all communication related to logistic movements. "), _c("br"), _vm._v(" The combination of the countries of the departure warehouse address of the order, and the country of the delivery, are used to define which address(es) is(are) notified about order logistic movements ")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("shipping");
      },
      paste: function paste($event) {
        return _vm.updateTags("shipping");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.shipping,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "shipping", $$v);
      },
      expression: "emailsDepartment.form.shipping"
    }
  }), ((_vm$emailsDepartment$3 = _vm.emailsDepartment.form.shippingLimited) === null || _vm$emailsDepartment$3 === void 0 ? void 0 : _vm$emailsDepartment$3.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.shippingLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "shippingLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("shipping", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("shipping", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("shipping", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("shipping");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Accounting")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v(" The accounting address is notified for all communication related to order delivered with financing option. ")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("accounting");
      },
      paste: function paste($event) {
        return _vm.updateTags("accounting");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.accounting,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "accounting", $$v);
      },
      expression: "emailsDepartment.form.accounting"
    }
  }), ((_vm$emailsDepartment$4 = _vm.emailsDepartment.form.accountingLimited) === null || _vm$emailsDepartment$4 === void 0 ? void 0 : _vm$emailsDepartment$4.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.accountingLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "accountingLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("accounting", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("accounting", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("accounting", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("accounting");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Compliance")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v(" The compliance address is notified for all communication related to customer satisfaction and order compliance, e.g. follow-up of orders and compliance with regulations. ")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("compliance");
      },
      paste: function paste($event) {
        return _vm.updateTags("compliance");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.compliance,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "compliance", $$v);
      },
      expression: "emailsDepartment.form.compliance"
    }
  }), ((_vm$emailsDepartment$5 = _vm.emailsDepartment.form.complianceLimited) === null || _vm$emailsDepartment$5 === void 0 ? void 0 : _vm$emailsDepartment$5.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.complianceLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "complianceLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("compliance", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("compliance", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("compliance", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("compliance");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Admin developers")]), _c("div", {
    staticClass: "settings-help-text"
  }, [_vm._v("For database-inconsistencies, for exemple.")]), _c(VCombobox, {
    attrs: {
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      disabled: _vm.emailsDepartment.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
    },
    on: {
      change: function change($event) {
        return _vm.updateTags("testing");
      },
      paste: function paste($event) {
        return _vm.updateTags("testing");
      }
    },
    model: {
      value: _vm.emailsDepartment.form.testing,
      callback: function callback($$v) {
        _vm.$set(_vm.emailsDepartment.form, "testing", $$v);
      },
      expression: "emailsDepartment.form.testing"
    }
  }), ((_vm$emailsDepartment$6 = _vm.emailsDepartment.form.testingLimited) === null || _vm$emailsDepartment$6 === void 0 ? void 0 : _vm$emailsDepartment$6.length) > 0 ? _c("div", {
    staticClass: "mb-3 ml-3"
  }, _vm._l(_vm.emailsDepartment.form.testingLimited, function (mailsLimited, i) {
    return _c("div", {
      key: "testingLimited-" + i,
      staticClass: "flex mb-4 pl-3 border-left-grey"
    }, [_c("div", {
      staticClass: "flex-grow"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field required",
      attrs: {
        placeholder: "Country",
        items: _vm.openedCountries,
        "item-value": "id_country",
        "item-text": "printable_name",
        rules: [_vm.formRules.mustSelectValue],
        disabled: _vm.emailsDepartment.saving.isPending,
        "hide-details": "auto",
        filter: _vm.filterVAutocomplete
      },
      model: {
        value: mailsLimited.countryId,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "countryId", $$v);
        },
        expression: "mailsLimited.countryId"
      }
    }), _c(VCombobox, {
      attrs: {
        multiple: "",
        "append-icon": "",
        chips: "",
        "deletable-chips": "",
        disabled: _vm.emailsDepartment.saving.isPending,
        rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeEmails]
      },
      on: {
        change: function change($event) {
          return _vm.updateTagsLimited("testing", i);
        },
        paste: function paste($event) {
          return _vm.updateTagsLimited("testing", i);
        }
      },
      model: {
        value: mailsLimited.mails,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "mails", $$v);
        },
        expression: "mailsLimited.mails"
      }
    }), _c("div", {
      staticClass: "d-flex align-center text-smaller"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: mailsLimited.isMainsInCopy,
        callback: function callback($$v) {
          _vm.$set(mailsLimited, "isMainsInCopy", $$v);
        },
        expression: "mailsLimited.isMainsInCopy"
      }
    }), _c("span", [_vm._v(" " + _vm._s(mailsLimited.isMainsInCopy ? "Mains email(s) will still receive the mails in copy" : "Mains email(s) will NOT receive the mails in copy") + " ")])], 1)], 1), _c("div", {
      staticClass: "ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-trash icon-link",
      attrs: {
        size: "1rem"
      },
      on: {
        click: function click($event) {
          return _vm.deleteSpecificCountryEmail("testing", i);
        }
      }
    })], 1)]);
  }), 0) : _vm._e(), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addSpecificCountryEmail("testing");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country specific email ")], 1)], 1)], 1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.resetEmails();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-undo mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Reset emails ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true,
      disabled: !_vm.emailsDepartment.form.isValid,
      loading: _vm.emailsDepartment.saving.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveEmails();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Save emails ")], 1)], 1)])], 1)]), _c(VTabItem, {
    key: 2
  }, [_c("div", {
    staticClass: "settings-tab"
  }, [_vm.isLoading ? _c(VSkeletonLoader, {
    attrs: {
      type: "card"
    }
  }) : _c(VForm, {
    staticClass: "settings-form",
    model: {
      value: _vm.identificationNumbers.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "isValid", $$v);
      },
      expression: "identificationNumbers.form.isValid"
    }
  }, [_c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("EORI")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label required",
    attrs: {
      disabled: _vm.identificationNumbers.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.identificationNumbers.form.eoriNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "eoriNumber", $$v);
      },
      expression: "identificationNumbers.form.eoriNumber"
    }
  })], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("FDA")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label required",
    attrs: {
      disabled: _vm.identificationNumbers.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.identificationNumbers.form.fdaNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "fdaNumber", $$v);
      },
      expression: "identificationNumbers.form.fdaNumber"
    }
  })], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Siret")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label required",
    attrs: {
      disabled: _vm.identificationNumbers.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.identificationNumbers.form.siretNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "siretNumber", $$v);
      },
      expression: "identificationNumbers.form.siretNumber"
    }
  })], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("TTB")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label",
    attrs: {
      hint: "You may change information of some internal importers if you change TTB here",
      disabled: _vm.identificationNumbers.saving.isPending
    },
    model: {
      value: _vm.identificationNumbers.form.ttbNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "ttbNumber", $$v);
      },
      expression: "identificationNumbers.form.ttbNumber"
    }
  })], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("Excise")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label required",
    attrs: {
      disabled: _vm.identificationNumbers.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.identificationNumbers.form.exciseNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "exciseNumber", $$v);
      },
      expression: "identificationNumbers.form.exciseNumber"
    }
  })], 1), _c("div", {
    staticClass: "settings-input"
  }, [_c("div", {
    staticClass: "settings-header"
  }, [_vm._v("VAT Intracom")]), _c(VTextField, {
    staticClass: "w90p v-text-field-no-label required",
    attrs: {
      disabled: _vm.identificationNumbers.saving.isPending,
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.identificationNumbers.form.vatIntracomNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.form, "vatIntracomNumber", $$v);
      },
      expression: "identificationNumbers.form.vatIntracomNumber"
    }
  })], 1), _c("div", {
    staticClass: "text-center"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.identificationNumbers.form.isValid,
      loading: _vm.identificationNumbers.saving.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveIdentificationNumbers();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Save identification numbers ")], 1)], 1)])], 1), _c("div", {
    staticClass: "mt-10"
  }, [_c("div", {
    staticClass: "text-larger text-bold"
  }, [_vm._v("Vat identification number per country")]), _vm._l(_vm.identificationNumbers.countryVat.getting.results, function (countryVat) {
    var _vm$identificationNum;
    return _c("div", {
      key: "countryVat-" + countryVat.id,
      staticClass: "mt-3 flex"
    }, [_c("div", [_vm._v(_vm._s(countryVat.country.name) + " :")]), ((_vm$identificationNum = _vm.identificationNumbers.countryVat.updating.form) === null || _vm$identificationNum === void 0 ? void 0 : _vm$identificationNum.id) !== countryVat.id ? _c("div", [_vm._v(" " + _vm._s(countryVat.vatNumber) + " ")]) : _c("div", [_c(VForm, {
      model: {
        value: _vm.identificationNumbers.countryVat.updating.form.isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.identificationNumbers.countryVat.updating.form, "isValid", $$v);
        },
        expression: "identificationNumbers.countryVat.updating.form.isValid"
      }
    }, [_c("div", {
      staticClass: "flex justify-start"
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        placeholder: "Vat identification number for country",
        disabled: _vm.identificationNumbers.countryVat.updating.isPending,
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.identificationNumbers.countryVat.updating.form.vatNumber,
        callback: function callback($$v) {
          _vm.$set(_vm.identificationNumbers.countryVat.updating.form, "vatNumber", $$v);
        },
        expression: "identificationNumbers.countryVat.updating.form.vatNumber"
      }
    }), _c("div", {
      staticClass: "ml-2 flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.isAnyActionInProgress,
        rounded: ""
      },
      on: {
        click: _vm.closeCountryVatEditForm
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        rounded: "",
        disabled: _vm.isAnyActionInProgress || !_vm.identificationNumbers.countryVat.updating.form.isValid,
        loading: _vm.identificationNumbers.countryVat.updating.isPending
      },
      on: {
        click: _vm.saveCountryVatEditForm
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Save vat number ")], 1)], 1)], 1)])], 1), !_vm.isAnyFormConfiguring && !_vm.isAnyActionInProgress ? _c("div", {
      staticClass: "flex ml-2"
    }, [_c(VIcon, {
      staticClass: "fa fa-pen text-sm ml-2 icon-link",
      attrs: {
        size: "0.8em"
      },
      on: {
        click: function click($event) {
          return _vm.startCountryVatEditForm(countryVat.id);
        }
      }
    }), _c(VIcon, {
      staticClass: "fa fa-trash text-sm ml-2 icon-link",
      attrs: {
        size: "0.8em"
      },
      on: {
        click: function click($event) {
          return _vm.confirmDeleteCountryVat(countryVat.id);
        }
      }
    })], 1) : _vm._e()]);
  }), !_vm.isAnyFormConfiguring && !_vm.isLoading ? _c("div", {
    staticClass: "mt-2 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.startCountryVatAddForm();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add new country ")], 1)], 1) : _vm.identificationNumbers.countryVat.adding.isConfiguring ? _c("div", {
    staticClass: "subform-bordered mt-4"
  }, [_c(VForm, {
    model: {
      value: _vm.identificationNumbers.countryVat.adding.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.countryVat.adding.form, "isValid", $$v);
      },
      expression: "identificationNumbers.countryVat.adding.form.isValid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field required",
    attrs: {
      placeholder: "Country",
      items: _vm.identificationNumbers.countryVat.availableCountries,
      "item-value": "id_country",
      "item-text": "printable_name",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.identificationNumbers.countryVat.adding.form.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.countryVat.adding.form, "countryId", $$v);
      },
      expression: "identificationNumbers.countryVat.adding.form.countryId"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      placeholder: "Vat identification number for country",
      disabled: _vm.identificationNumbers.countryVat.adding.isPending,
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.identificationNumbers.countryVat.adding.form.vatNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.identificationNumbers.countryVat.adding.form, "vatNumber", $$v);
      },
      expression: "identificationNumbers.countryVat.adding.form.vatNumber"
    }
  }), _c("div", {
    staticClass: "mt-1 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.closeCountryVatAddForm
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.identificationNumbers.countryVat.adding.form.isValid,
      loading: _vm.identificationNumbers.countryVat.adding.isPending
    },
    on: {
      click: _vm.saveCountryVatAddForm
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save new vat number ")], 1)], 1)], 1)], 1) : _vm._e()], 2)])], 1)], 1), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };